<template>
  <ui-select
    :value="store.dashboardQueryTemporary.currency"
    @change="onChange"
    class="currency-picker"
    :items="currencyListOrderedPreferred"
    item-text="text"
    item-value="code"
    :autocomplete="false"
    :hide-details="1"
    :menu-props="{
      minWidth: 220,
      left: true,
    }"
  >
    <template #selection="{ item }">
      <div class="v-select__selection--comma">
        <div class="currency-picker__currency-icon">{{ icon }}</div>
        <span class="currency-picker__currency-text">
          {{ item.raw.code }}
        </span>
      </div>
    </template>

    <template #item="{ item }">
      <div
        class="v-list__tile__title"
        style="display: flex; justify-content: space-between; flex-grow: 1"
      >
        <span class="currency-picker__currency-text">
          {{ item.raw.name }}
        </span>
        <div class="currency-picker__currency-icon">{{ item.raw.sign }} {{ item.raw.code }}</div>
      </div>
    </template>
  </ui-select>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import query from '@/components/query/query-constructor';
import { useCurrencyList } from '@/composables';
import { useStore } from '@/store';

const route = useRoute();
const store = useStore();
const { currencyListOrderedPreferred, currenciesLowerCase } = useCurrencyList();

const icon = computed(() => {
  const name = (store.dashboardQueryTemporary.currency || 'usd').toLowerCase();
  return currenciesLowerCase.value[name];
});

const onChange = (value: string) => {
  store.patchDashboardQueryTemporaryField({
    name: 'currency',
    value,
  });
};

onMounted(() => {
  const routeParams = query.decode(route.params.data as string) || {};
  const { currency } = routeParams;
  const nextCurrency = currency || store.user.currencyId;
  if (store.dashboardQueryTemporary.currency !== nextCurrency) {
    store.patchDashboardQueryTemporaryField({
      name: 'currency',
      value: nextCurrency,
    });
  }

  store.applyDashboardQuery();
});
</script>

<style lang="scss">
</style>
